import { Url } from "@didi/mfe-global-utils";

/**
 * 安全地对字符串执行 decodeURIComponent 操作。
 * 当传入值包含非法 URL 编码时不会抛出异常，而是返回原始字符串。
 * @param {string} value 需要解码的字符串
 * @returns {string} 解码后的字符串或原始字符串
 */
const safeDecode = (value: string): string => {
    if (!value) return '';
    try {
        return decodeURIComponent(value);
    } catch {
        return value;
    }
};

/**
 * 当第三方 Url.getQuerySet 解析失败时，从 window.location.search 手动解析 query。
 * 对每个键值对尝试 decodeURIComponent，若解码失败则保留原始值，避免抛出 URIError。
 * @returns 解析后的查询参数对象
 */
const parseQueryFromLocation = (): Record<string, string> => {
    if (typeof window === "undefined") {
        return {};
    }
    const search = window.location.search || "";
    const query = search.charAt(0) === "?" ? search.slice(1) : search;
    const params: Record<string, string> = {};

    if (!query) {
        return params;
    }

    query.split("&").forEach((pair) => {
        if (!pair) return;
        const [rawKey, rawValue = ""] = pair.split("=");
        if (!rawKey) return;
        const key = safeDecode(rawKey);
        const value = safeDecode(rawValue);
        params[key] = value;
    });

    return params;
};


/**
 * 获取安全的 querySet。
 * 优先使用第三方 Url.getQuerySet；若解析过程中抛出 URIError，
 * 则退回到本地的 parseQueryFromLocation 解析，以保证页面不因异常中断。
 * @returns 解析后的查询参数对象
 */
const getSafeQuerySet = () => {
    try {
        return Url.getQuerySet() as any;
    } catch {
        return parseQueryFromLocation();
    }
};

export const querySet = getSafeQuerySet();
export const safeGetQuerySet = getSafeQuerySet;
export const safeDecodeURIComponent = safeDecode;
